import { render, staticRenderFns } from "./modal_desbloqueo.vue?vue&type=template&id=89e87a2a&scoped=true"
import script from "./modal_desbloqueo.vue?vue&type=script&lang=js"
export * from "./modal_desbloqueo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e87a2a",
  null
  
)

export default component.exports